import { Component } from '@angular/core';

@Component({
    selector: 'unauthorized',
    templateUrl: './unauthorized.component.html',
    styleUrls: ['./unauthorized.component.css']
})
/** unauthorized component*/
export class UnauthorizedComponent {
    /** unauthorized ctor */
    constructor() {

    }
}